import { Component, OnInit } from '@angular/core';
import { Location } from '@angular/common';
declare var $: any;
import swal from 'sweetalert2';
import { environment } from '../../../environments/environment';

@Component({
    selector: 'app-science',
    templateUrl: './science.component.html',
    styleUrls: ['./science.component.scss'],
    standalone: false
})
export class ScienceComponent implements OnInit {
  currentIndex: number = 1;
  maxIndex: number = 5;
  minIndex: number = 1;
  carousel: any;
  education: boolean = environment.instanceType === 'education';

  constructor(private _location: Location) { }

  ngOnInit() {
    $('body').removeClass();
    $('.carousel').on('slid.bs.carousel', ($event) => this.currentIndex = $event.to + 1);
    this.maxIndex = $('.carousel .carousel-item').length;
    $('body').addClass('withOverflow');
  }

  onNext() {
    $('.carousel').carousel('next');
  }

  onBack() {
    if (this.currentIndex == this.minIndex) {
      this._location.back();
    }
    $('.carousel').carousel('prev');
  }

  ngOnDestroy() {
    $('body').removeClass('withOverflow');
  }

  onShowPopup(contentType = 0) {
    let content = `<h1>Measuring Unconscious Bias<br/>– a literature review</h1>
        <br/>
        <p>by Dr Lara Zibarras & Dr Kelly Winstanley</p>
        <br/>
        <br/>
        <br/>
        <p>The following report outlines a review of the literature on unconscious bias; in particular, how unconscious bias is currently measured, and what interventions exist that aim to reduce unconscious bias. After the introduction and methodology, our review has three main parts:</p>
        <br/><br/>
        <ul>
          <li>What methods exist currently for testing unconscious bias?</li>
          <li>Review of interventions that exist to reduce unconscious bias; how good are they?</li>
          <li>What are the lessons learnt?</li>
        </ul>
        <br/><br/>
        <p>A number of methods exist for testing unconscious bias. The predominant method is the Implicit Association Test (IAT) and alongside the standard IAT are its various derivatives (Brief IAT; Personalised IAT; Single Categories IAT). Although the IAT is the dominant method used within the research literature, it has also been subject to critique around its reliability and validity and our findings suggest it is difficult to draw clear conclusions on the utility of the IAT.</p>
        <br/><br/>
        <p>In addition to the IAT and its derivatives are other methods of testing for unconscious bias; including the Go No-Go association task; semantic priming and lexical decision task; evaluative priming task; should-would discrepancies scale; the affect misattribution procedure; and the bias awareness scale. The research literature for these other measures is much less extensive.</p>
        <br/><br/>
        <p>We uncovered a number of studies where the intention was to reduce bias. In this report, we categorised unconscious bias training interventions into six different techniques:</p>
        <br/><br/>
        <ol>
          <li>Discounting commonly held stereotypes;</li>
          <li>Using context to influence implicit responses;</li>
          <li>Changing the way an out-group member is evaluated and categorised;</li>
          <li>Using contact to change the level of threat evoked by an out group;</li>
          <li>Mindfulness Meditation; and</li>
          <li>Encouraging people to take responsibility for their implicit biases.</li>
        </ol>
        <br/><br/>
        <p>Whilst there were aspects of some of the methods that appeared to work in reducing implicit bias, again there is much critique levied at research around the extent to which it is actually bias that is being reduced, or whether the “reduction” is due to issues with the measure of bias itself. Nevertheless, a “good” intervention is likely to include multiple methods; be longitudinal in design; and actively involve participants throughout the process.</p>
        <br/><br/>
        <p>In conclusion, the areas of unconscious bias, its measurement and training interventions are ones that have garnered much attention both in the academic and practitioner literatures. Unconscious bias is seen as something that is important to deal with in organisations, yet at present there are many areas within the academic literature that lack clarity. First, there is no one technique to measure unconscious bias that is considered “good” by the majority of researchers; and second the research on interventions to reduce unconscious bias is patchy at best. One key issue is that the “interventions” have often been conducted in a way that hides the true nature of the task, which questions their relevance in an organisational setting.</p>
        <br/><br/>
        <p>The full report can be found <a class="dark-link dot-underline" target=_blank href="/assets/Measuring_Unconscious_Bias_Report.pdf">here</a>.</p>
        `;
    if (contentType == 1) {
      content = `
      <img src="/assets/img/report-01.jpg" srcset="/assets/img/report-01@2x.jpg 2x, /assets/img/report-01@3x.jpg 3x">
        <br/>
        <br/>
        <h1>Unconscious Bias In Graduate Recruitment</h1>
        <br/>
        <h4>Rare’s aim</h4>
        <p>There are many reports and initiatives on unconscious bias. We wanted a new approach that draws on our access to young, high achieving, under-represented, students in ways that can actively improve the recruitment process.</p>
        <br/>
        <h4>What we learned</h4>
        <p>The research on the unconscious is clear: we are all susceptible to a multitude of so-called unconscious biases; these biases are hardwired into our neural circuitry and exhibited in all of our everyday actions.</p>
        <br/>
        <p>Capital: a person’s economic, social and cultural capital is not only relevant to how they appear on paper but how they appear in person – especially, the extra-discursive dimensions of their presence – how often might we produce evaluative phrases such as: ‘she was very warm and personable’, for example?</p>
        <br/>
        <p>Cultural literacy: there exists a cultural, linguistic and social canon. This canon is, by its very nature, ‘the way things get done’. It is a metalanguage that enables social and business interaction. Not having access to, or experience of, this canon may place individuals at unfair, largely unconscious, disadvantages.</p>
        <br/>
        <p>Recruitment process: a blend of blind and contextualised stages will offer the most realistic and egalitarian recruitment process. We must control the information in the system: the best systems are both hyper-contextualised and blind.</p>
        <br/>
        <p>‘It’: we questioned what judgements are being made in an interview and how they might betray their conscious aim. When a particular candidate impresses us, when that candidate has ‘it’, what is ‘it’ and how might it informed by biases – feelings of warmth, comfort and familiarity, for example? These essays collectively attempt to describe ‘it’.</p>
        <br/>
        <h4>Outcomes / recommendations</h4>
        <p>There are two chapters that follow the series of essays: Rare recommends, and Rare’s Five Big Ideas for 2015. These chapters led directly to the development of Hemisphere.</p>
        <br/>
        <p>The full research report can be found <a class="dark-link dot-underline" target=_blank href="https://www.raretechnology.com/static/research/2014_UB_in_graduate_recruitment.pdf">here</a>.</p>
        `;
    }

    swal({
      title: '',
      customClass: 'welcome-alert',
      html: content,
      showCloseButton: true,
      showCancelButton: false,
      showConfirmButton: false
    });
  }
}
